import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyCreateContact = lazyWithRetry(() => import("./CreateContact"));

const CreateContact = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyCreateContact {...props} />;

export default CreateContact;
